import React from 'react'
import { InputNumber } from 'antd'

export default ({ input, field }) => (<InputNumber input={input} {...input} {...field.attrs} />)

